import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';

import { cn } from '../../lib/utils';

// Create properly typed motion components
const MotionDiv = motion.div;

interface TestimonialProps {
  text: string;
  author?: string;
  company?: string;
  className?: string;
}

export function Testimonial({
  text,
  author,
  company,
  className,
}: TestimonialProps) {
  return (
    <MotionDiv
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}      className={cn(
        "bg-white dark:bg-navy-light rounded-lg p-10 border border-gray-100 dark:border-navy shadow-sm",
        className
      )}
    >
      {(author || company) && (
        <div className="mb-6 text-center">
          {author && <p className="font-semibold text-gray-900 dark:text-white leading-snug text-lg">{author}</p>}
          {company && <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 leading-relaxed">{company}</p>}
        </div>
      )}
      <Quote className="h-10 w-10 text-primary mb-6 opacity-40 mx-auto" />
      <p className="text-lg mb-8 text-gray-700 dark:text-gray-300 italic leading-relaxed">
        "{text}"
      </p>
    </MotionDiv>
  );
}


